import React, { Component } from 'react';
import { connect } from 'react-redux';
import Can from '../common/guards/can';
import SideMenuItem from './menu-item';
import SideMenuDropdown from './menu-dropdown';
import { Scrollbars } from 'react-custom-scrollbars';
import { navBarLinks, navBarLinksAdmin } from '../../data/navbarLinks';

// import './sidenav.css';

class SideNav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scrollTop: 0,
      openedMenu: this.getOpenedMenu()
    };
  }

  componentDidMount() {
    if (this.refs.scrollbarRef) {
      this.refs.scrollbarRef.trackVertical.style.setProperty('position', 'absolute');
      this.refs.scrollbarRef.trackVertical.style.setProperty('width', '8px');
      this.refs.scrollbarRef.trackVertical.style.setProperty('right', '0px');
      this.refs.scrollbarRef.trackVertical.style.setProperty('bottom', '2px');
      this.refs.scrollbarRef.trackVertical.style.setProperty('top', '2px');
      this.refs.scrollbarRef.trackVertical.style.setProperty('border-radius', '3px');
      this.refs.scrollbarRef.trackVertical.style.setProperty('background-color', '#7e1129');
      this.refs.scrollbarRef.thumbVertical.style.setProperty('background-color', '#d80d48');
      this.refs.scrollbarRef.view.style.setProperty('overflow-x', 'hidden');
    }
  }

  handleEnter = () => {
    this.setState({
      scrollTop: this.state.scrollTop
    });
  };

  getOpenedMenu = () => {
    return localStorage.getItem('navbarToggles') || '';
  };

  toggleMenu = (key) => {
    const currentKey = localStorage.getItem('navbarToggles');

    if (currentKey === key) {
      localStorage.setItem('navbarToggles', '');
      this.setState({openedMenu: ''});
    } else {
      localStorage.setItem('navbarToggles', key);
      this.setState({openedMenu: key});
    }
  };

  render() {
    const links = this.props.admin ? navBarLinksAdmin : navBarLinks;
    const heightMin = this.props.admin ? 'calc(100vh - 150px)' : 'calc(100vh - 300px)';
    const features = this.props.features;

    return (
      <Scrollbars autoHide
                  autoHeight
                  autoHeightMin={heightMin}
                  autoHeightMax={heightMin}
                  ref="scrollbarRef"
      >
        <ul className="sidebar-nav"
            id="sidebar-nav">
            {links.map((item, index) => {
                let action       = true,
                    subjectClass = '';
                if (item.permissions) {
                    action = item.permissions.action;
                    subjectClass = item.permissions.subjectClass;
                }
                if (item.hasOwnProperty('children')) {
                    const key = 'dd_' + index;
                    const className = item.hasOwnProperty('className') ? 'nav-item ' + item.className : 'nav-item';

                    return (
                        <Can action={action} subjectClass={subjectClass} key={key}>
                          <SideMenuDropdown className={className}
                                            title={item.title}
                                            toggleKey={key}
                                            handleOpen={this.toggleMenu}
                                            open={this.state.openedMenu === key}>
                              {item.children.map((child, childKey) => {
                                  let childAction       = true,
                                      childSubjectClass = '';
                                  if (child.permissions) {
                                      childAction = child.permissions.action;
                                      childSubjectClass = child.permissions.subjectClass;
                                  }
                                  return (
                                      <Can action={childAction} subjectClass={childSubjectClass} key={"sidenav_" + childKey}>
                                        {
                                          !features[child.hideForFeature]
                                            && <SideMenuItem href={child.href} id={"sidenav_" + childKey} title={child.title}/>
                                        }
                                      </Can>
                                  )
                              })}
                          </SideMenuDropdown>
                        </Can>
                    )
                }
                return (
                    <Can action={action} subjectClass={subjectClass} key={"sidenav_" + index}>
                      <SideMenuItem href={item.href} id={"sidenav_" + index} title={item.title} handleOpen={this.toggleMenu}/>
                    </Can>
                )
            })}
        </ul>
      </Scrollbars>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    features: state.features
  };
};

export default connect(mapStateToProps)(SideNav);



// WEBPACK FOOTER //
// ./src/components/sidenav/index.jsx